export const STONLY_WIDGET_SCRIPT_ATTR = 'data-stonly-widget';
export const STONLY_WIDGET_DOM_SELECTOR = 'iframe[src*="stonly.com"], [id="stonly-widget"]';

export interface IShouldLoadStonlyWidgetParams {
    stonlyEnabled: boolean;
    platformConfigurationLoaded: boolean;
    isLocalHost: boolean;
    isShadowAuth: boolean;
    isInExportView: boolean;
    hasExportQuery: boolean;
}

export const shouldLoadStonlyWidget = ({
    stonlyEnabled,
    platformConfigurationLoaded,
    isLocalHost,
    isShadowAuth,
    isInExportView,
    hasExportQuery
}: IShouldLoadStonlyWidgetParams): boolean =>
    platformConfigurationLoaded
    && stonlyEnabled
    && !isLocalHost
    && !isShadowAuth
    && !isInExportView
    && !hasExportQuery;

export const isStonlyScriptAdded = (): boolean =>
    !!document.querySelector(`script[${STONLY_WIDGET_SCRIPT_ATTR}]`);

export const setStonlyWidgetVisibility = (visible: boolean): void => {
    document.querySelectorAll<HTMLElement>(STONLY_WIDGET_DOM_SELECTOR).forEach(element => {
        element.hidden = !visible;
        element.style.display = visible ? '' : 'none';
    });
};
